const GTM_ID = process.env.REACT_APP_GTM_ID;

/**
 * Dynamically injects the GTM script into the page.
 * Safe to call multiple times — won't double-inject.
 */
export function initGTM() {
  if (!GTM_ID || typeof window === 'undefined' || window.__gtmLoaded) return;

  // Initialise dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  // Inject <script> into <head>
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  // Inject <noscript> iframe into <body>
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.cssText = 'display:none;visibility:hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);

  window.__gtmLoaded = true;
}

/**
 * Push a custom event to the GTM dataLayer.
 * Usage: pushEvent('add_to_cart', { value: 24.99, currency: 'GBP' })
 */
export function pushEvent(event, data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}
